import { render, staticRenderFns } from "./FullScreenImageCarousel.vue?vue&type=template&id=a5a3f644&scoped=true&"
import script from "./FullScreenImageCarousel.vue?vue&type=script&lang=js&"
export * from "./FullScreenImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenImageCarousel.vue?vue&type=style&index=0&id=a5a3f644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a3f644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VCol,VDialog,VFabTransition,VIcon,VImg,VRow})
